import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import axios from 'axios';
import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SIcon } from '../../shared/Icon';
import { Theme } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';

import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
	},

	mainPage: {
		display: 'grid',
		gridTemplateRows: '1.5fr 5fr',
	},
	title: {
		margin: '5vh 0px 0px 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		display: 'flex',
		gap: '10vw',
	},
	logo: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'stretch',
		//border: 'solid white',
		margin: '5vh 0px',
		borderWidth: '0px 0px 1px 0px',
		//cursor: 'pointer',
		'& img': {
			width: '30px',
			maxHeight: '50%',
			height: '30px',
			margin: '12px 5px 0px 9%',
		},
		'& #name': {
			display: 'inline-block',
			margin: '10px 0px 0px 0px',
			width: 'calc(91% - 35px)',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
		'& #welcome': {
			display: 'block',
			margin: '5px 0px 0px 9%',
			fontFamily: 'NanumR',
			fontSize: '1.2rem',
		},
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	info: {
		float: 'left',
		fontFamily: 'NanumR',
		fontSize: '1.5vw',
		fontWeight: 'bold',
		color: `${COLORS.CHARCHOAL_GREY}`,
		marginBottom: '10vh',
		marginTop: '-10vh',
	},
	menu: {
		display: 'grid',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		'&::after': {
			content: '""',
			position: 'absolute',
			width: '0',
			height: '0',
			left: '50%',
			bottom: '0',
			borderBottom: '3px solid black',
			transition: 'width 0.3s ease, left 0.3s ease',
			WebkitTransition: 'width 0.3s ease, left 0.3s ease',
		},
		'&:hover::after': {
			width: '100%',
			left: '0',
		},
		'&:hover': {
			backgroundColor: 'transparent', // hover 배경색 제거
		},
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '1fr 2fr',
		marginTop: '1%',
		//fontSize: '5vw',
		//backgroundColor: `${COLORS.WHITE}`,
	},
	subTitle: {
		minWidth: '10vw',
		display: 'flex',
		flexDirection: 'column',
	},
	menuOpen: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		alignItems: 'center',
		marginTop: '10px',
		gap: '10px',
		'& a': {
			margin: '5px',
			fontSize: '1rem',
			width: 'fit-content',
			height: '100%',
			cursor: 'pointer',
			textAlign: 'center',
			position: 'relative',
			'&::after': {
				content: '""',
				position: 'absolute',
				display: 'inline-block',
				width: '0',
				height: '0',
				left: '50%',
				bottom: '-5px',
				borderBottom: '2px solid black',
				transition: 'width 0.3s ease, left 0.3s ease',
				WebkitTransition: 'width 0.3s ease, left 0.3s ease',
			},
			'&:hover::after': {
				width: '100%',
				left: '0',
			},
		},
	},
	menuClose: {
		display: 'none',
	},
	classList: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	buttonTable: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr 1fr 1fr',
		margin: '0 10px',
	},
	buttonTable2: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
		margin: '0 10px',
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 6fr 3fr 3fr',
		padding: '25px 0',
		backgroundColor: `${COLORS.LIGHT_GREY}`,
	},
	textLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: `${COLORS.CHARCHOAL_GREY}`,
		fontSize: 18,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
	},
	buttonLabel: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		color: `${COLORS.CHARCHOAL_GREY}`,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
	},
	infoButton: {
		//borderWidth: 2,
		//borderStyle: 'solid',
		//borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		borderRadius: '30px',
		margin: '0.5vh',
		width: '15vw',
		height: '35vh',
		'&:hover': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	deleteButton: {
		//borderWidth: 2,
		//borderStyle: 'solid',
		//borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.PUMPKIN}`,
		color: `${COLORS.WHITE}`,
		borderRadius: '30px',
		margin: '0.5vh',
		width: '15vw',
		height: '35vh',
		'&:hover': {
			color: `${COLORS.PUMPKIN}`,
		},
	},
	buttonFont: {
		//color: `${COLORS.WHITE}`,
		fontSize: '3vw',
	},
}));

interface TitleComponentProps {
	menu: boolean;
	operMenu: boolean;
	setMenu: (value: boolean) => void;
	setOperMenu: (value: boolean) => void;
	moveClassList: () => void;
	moveClassManage: () => void;
	moveOperList: () => void;
}

const TitleComponent: React.FC<TitleComponentProps> = ({ menu, operMenu, setMenu, setOperMenu, moveClassList, moveClassManage, moveOperList }) => {
	const classes = useStyles();
	return (
		<div className={classes.title}>
			<div className={classes.subTitle} onMouseOver={() => setMenu(true)} onMouseOut={() => setMenu(false)}>
				<Button className={classes.menu} onClick={() => moveClassList()}>
					교육
				</Button>
				<div className={menu ? classes.menuOpen : classes.menuClose}>
					<a onClick={moveClassList}>교육 목록</a>
					<a onClick={moveClassManage}>교육 관리 목록</a>
				</div>
			</div>
			<div className={classes.subTitle} onMouseOver={() => setOperMenu(true)} onMouseOut={() => setOperMenu(false)}>
				<Button className={classes.menu} onClick={() => moveOperList()}>
					강사
				</Button>
				<div className={operMenu ? classes.menuOpen : classes.menuClose}>
					<a onClick={moveOperList}>강사 관리</a>
				</div>
			</div>
		</div>
	);
};

interface ButtonTableComponentProps {
	classStatus: string;
	moveStartPage: () => void;
	moveModifyPage: () => void;
	moveInfoPage: () => void;
	updateStatus: (status: string) => void;
	moveRankPage: () => void;
}

const ButtonTableComponent: React.FC<ButtonTableComponentProps> = ({ classStatus, moveStartPage, moveModifyPage, moveInfoPage, updateStatus, moveRankPage }) => {
	const classes = useStyles();
	if (classStatus === '교육전') {
		return (
			<div className={classes.buttonTable2}>
				<div></div>
				<div></div>
				<Button className={classes.infoButton} onClick={() => updateStatus('ing')}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						시작하기
					</Typography>
				</Button>
				<div></div>
				<div></div>
			</div>
		);
	} else if (classStatus === '교육중') {
		return (
			<div className={classes.buttonTable}>
				<Button onClick={moveStartPage} className={classes.infoButton}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						진행하기
					</Typography>
				</Button>
				<Button onClick={moveModifyPage} className={classes.deleteButton}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						수정하기
					</Typography>
				</Button>
				<Button onClick={moveInfoPage} className={classes.infoButton}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						인원조회
					</Typography>
				</Button>
				<Button onClick={() => updateStatus('finish')} className={classes.deleteButton}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						종료하기
					</Typography>
				</Button>
			</div>
		);
	} else if (classStatus === '교육 완료') {
		return (
			<div className={classes.buttonTable}>
				<div></div>
				<Button onClick={moveInfoPage} className={classes.infoButton}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						인원조회
					</Typography>
				</Button>
				<Button onClick={moveRankPage} className={classes.deleteButton}>
					<Typography className={classes.buttonFont}>
						교육
						<br />
						결과조회
					</Typography>
				</Button>
				<div></div>
			</div>
		);
	} else {
		return null;
	}
};

const SubAdminClassManageNav = (props: any) => {
	const classes = useStyles();
	let history = useHistory();
	const state: any = history.location.state;
	const classCode = state.code;
	const className = state.name;
	const [classStatus, setClassStatus] = useState<any>();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [menu, setMenu] = useState<boolean>(false);
	const [operMenu, setOperMenu] = useState<boolean>(false);

	const { member } = props;

	const updateStatus = (classStatus: any) => {
		console.log(classStatus);
		axios({
			method: 'POST',
			data: {
				classCode: classCode,
				classStatus: classStatus,
			},
			withCredentials: true,
			url: SERVER + v_admin.admin + v_admin.update_status,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					selectStatus();
				} else {
					if (data.code == Values.FAIL_CODE) {
						enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
							variant: 'error',
							autoHideDuration: SNACKBAR_TIME,
						});
					}
				}
			});
	};

	const selectStatus = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.search_status);
		let params = { classCode: classCode.toString() };
		url.search = new URLSearchParams(params).toString();
		console.log(classCode);
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.search_status,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					console.log(data.data[0].class_status);
					if (data.data[0].class_status == 'wait') {
						setClassStatus('교육전');
					}
					if (data.data[0].class_status == 'ing') {
						setClassStatus('교육중');
					}
					if (data.data[0].class_status == 'finish') {
						setClassStatus('교육 완료');
					}
				}
			});
	};

	const moveClassList = () => {
		history.push('/subAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/subAdminClassManage');
	};
	const moveOperList = () => {
		history.push('/subAdminOperList');
	};

	const moveModifyPage = () => {
		console.log(classCode);
		console.log(className);
		history.push({
			pathname: '/subAdminModifyClass',
			state: {
				// location state
				code: classCode,
				name: className,
			},
		});
	};

	const moveInfoPage = () => {
		console.log(classCode);
		console.log(className);
		history.push({
			pathname: '/subAdminClassMember',
			state: {
				// location state
				code: classCode,
				name: className,
			},
		});
	};

	const moveStartPage = () => {
		console.log(classCode);
		console.log(className);
		history.push({
			pathname: '/subAdminClassRun',
			state: {
				// location state
				code: classCode,
				name: className,
			},
		});
	};

	const moveRankPage = () => {
		console.log(classCode);
		console.log(className);
		history.push({
			pathname: '/subAdminOpenRanking',
			state: {
				// location state
				code: classCode,
				name: className,
			},
		});
	};

	useEffect(() => {
		selectStatus();
	}, []);
	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<div className={classes.navigator}>
						<div className={classes.logo}>
							<img src="/images/p.webp" alt="logo" />
							<Typography id="name">플레이스타트업</Typography>
							<Typography id="welcome">{member.name}님, 환영합니다!</Typography>
						</div>
						<TitleComponent
							menu={menu}
							operMenu={operMenu}
							setMenu={setMenu}
							setOperMenu={setOperMenu}
							moveClassList={moveClassList}
							moveClassManage={moveClassManage}
							moveOperList={moveOperList}
						/>
					</div>
					<div className={classes.classList}>
						<Typography className={classes.info}>
							현재 접속 중인 메뉴의 교육명은 {className}입니다. <br />
							현재 교육 상태는 {classStatus}입니다.
						</Typography>
						<ButtonTableComponent
							classStatus={classStatus}
							moveStartPage={moveStartPage}
							moveModifyPage={moveModifyPage}
							moveInfoPage={moveInfoPage}
							updateStatus={updateStatus}
							moveRankPage={moveRankPage}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SubAdminClassManageNav;
